import TeacherService from "@/services/TeacherService";
import SearchService from "@/services/SearchService";
import router from "@/router";

const uuidv4 = require("uuid/v4");

const getDefaultState = () => ({
  teacher: {
    id: null,
    uuid: "",
    first_name: "",
    middle_name: "",
    last_name: "",
    sex: "",
    mobile_1: "",
    mobile_2: "",
    teacher_group_id: "",
    dob: null,
    email: "",
    country: "",
    region: "",
    district: "",
    village: "",
    address: "",
    active: false,
    head_teacher: false,
    education_primary: false,
    education_secondary: false,
    education_diploma: false,
    education_degree: false,
    education_other: "",
    user_flagged_duplicate: false,
  },
  teachers: [],
  teacherStudent: {
    id: "",
    student_id: "",
    teacher_id: "",
    student_uuid: "",
    teacher_uuid: "",
    active: false,
  },
  teacherStudents: [],
  teacherParents: [],
  parentWorkshops: [],
  parentCertificates: [],
  teacherExport: [],
  modules: [],
});

const teachers = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetTeachers(state) {
      Object.assign(state, getDefaultState());
    },
    active(state, val) {
      state.teacher.active = val;
    },
    head_teacher(state, val) {
      state.teacher.head_teacher = val;
    },
    first_name(state, val) {
      state.teacher.first_name = val;
    },
    middle_name(state, val) {
      state.teacher.middle_name = val;
    },
    last_name(state, val) {
      state.teacher.last_name = val;
    },
    dob(state, val) {
      state.teacher.dob = val;
    },
    teacher_group_id(state, val) {
      state.teacher.teacher_group_id = val;
    },
    sex(state, val) {
      state.teacher.sex = val;
    },
    mobile_1(state, val) {
      state.teacher.mobile_1 = val;
    },
    mobile_2(state, val) {
      state.teacher.mobile_2 = val;
    },
    email(state, val) {
      state.teacher.email = val;
    },
    country(state, val) {
      state.teacher.country = val;
    },
    region(state, val) {
      state.teacher.region = val;
    },
    district(state, val) {
      state.teacher.district = val;
    },
    village(state, val) {
      state.teacher.village = val;
    },
    address(state, val) {
      state.teacher.address = val;
    },
    education_primary(state, val) {
      state.teacher.education_primary = val;
    },
    education_secondary(state, val) {
      state.teacher.education_secondary = val;
    },
    education_diploma(state, val) {
      state.teacher.education_diploma = val;
    },
    education_degree(state, val) {
      state.teacher.education_degree = val;
    },
    education_other(state, val) {
      state.teacher.education_other = val;
    },
    user_flagged_duplicate(state, val) {
      state.teacher.user_flagged_duplicate = val;
    },
    teacherStudents(state, val) {
      state.teacherStudents = val;
    },
    teacherParents(state, val) {
      state.teacherParents = val;
    },
    parentWorkshops(state, val) {
      state.parentWorkshops = val;
    },
    parentCertificates(state, val) {
      state.parentCertificates = val;
    },
    teachers(state, val) {
      state.teachers = val;
    },
    modules(state, val) {
      state.modules = val;
    },
  },
  actions: {
    async CREATE_TEACHER({ state }) {
      const key = await "dob";
      state.teacher.birthdate = await state.teacher[key];
      state.teacher.uuid = uuidv4();
      await delete state.teacher[key];
      await TeacherService.addTeacher(state.teacher);
    },
    async GET_TEACHERS(context) {
      let data;
      if (context.rootState.auth.user.admin) {
        const res = await TeacherService.fetchTeachers();
        data = res.data.teachers;
        //console.log("normal call data: ", data);
      }else if (context.rootState.auth.user.src) {
        const user_uuid = context.rootState.auth.user.uuid;
        const res = await TeacherService.fetchClusterTeachers(user_uuid);
        data = res.data.teachers;
      }  else if (context.rootState.auth.coordinator.uuid.length > 0) {
        const res = await TeacherService.fetchCoordinatorTeachers(
          context.rootState.auth.coordinator.uuid
        );
        data = res.data.teachersFull;
        //console.log("coordinator call data: ", data);
      } else {
        const res = await TeacherService.fetchTrainerTeachers(
          context.rootState.auth.trainer.uuid
        );
        data = res.data.teachers;
        //console.log("trainer call data: ", data);
      }

      context.commit("teachers", data);
    },
    async GET_TEACHER_NAMES(context) {
      const res = await TeacherService.fetchTeacherNames();
      const data = res.data.teachers;
      context.rootState.teachers.teachers = data;
    },
    async GET_TEACHERS_EXPORT(context) {
      const res = await TeacherService.fetchTeachersExport();
      const data = res.data.teachers;
      context.rootState.teachers.teachersExport = data;
    },
    async GET_TEACHER(context) {
      const teacher = await TeacherService.getTeacher({
        id: router.currentRoute.params.id,
      });
      const data = teacher.data.teacher[0];
      context.rootState.teachers.teacher = data;
    },
    async UPDATE_TEACHER({ state }) {
      // important to rename dob before posting
      const key = await "dob";
      state.teacher.birthdate = await state.teacher[key];
      await delete state.teacher[key];
      await TeacherService.updateTeacher(state.teacher);
    },
    async GET_SCHOOL_TEACHERS(context) {
      const teachers = await TeacherService.fetchTeachersBySchool({
        id: context.rootState.observations.observation.school,
      });
      const data = teachers.data.teachers;
      context.rootState.teachers.teachers = data;
    },
    async GET_SCHOOL_WS_TEACHERS(context) {
      const teachers = await TeacherService.fetchTeachersBySchool({
        id: context.rootState.workshops.workshop.school,
      });
      const data = teachers.data.teachers;
      context.rootState.teachers.teachers = data;
    },
    async GET_TEACHER_STUDENTS(context) {
      const students = await TeacherService.fetchTeacherStudents({
        id: router.currentRoute.params.id,
      });
      const data = students.data.students;
      context.commit("teacherStudents", data);
    },
    async GET_TEACHER_PARENTS(context) {
      const parents = await TeacherService.fetchTeacherParents({
        id: router.currentRoute.params.id,
      });

      const data = parents.data.results;
      context.commit("teacherParents", data);
    },
    async GET_TEACHER_PARENT_WORKSHOPS(context) {
      const workshops = await TeacherService.fetchTeacherParentWorkshops({
        id: router.currentRoute.params.id,
      });
      const data = workshops.data.results;
      const tempData = [];
      data.forEach((element) => {
        let inTemp = false;
        tempData.forEach((temp) => {
          if (temp.date == element.date && temp.id == element.id) {
            temp.parents_names += element.parents_names;
            inTemp = true;
          }
        });
        if (!inTemp) {
          tempData.push(element);
        }
      });
      console.log("workshop data: ", tempData);
      context.commit("parentWorkshops", tempData);
    },
    async GET_TEACHER_PARENT_CERTIFICATES(context) {
      const certificates = await TeacherService.fetchTeacherParentCertificates({
        id: router.currentRoute.params.id,
      });
      const data = certificates.data.results;
      const tempData = [];
      data.forEach((element) => {
        let inTemp = false;
        tempData.forEach((temp) => {
          if (temp.date == element.date && temp.id == element.id) {
            temp.parents_names += element.parents_names;
            inTemp = true;
          }
        });
        if (!inTemp) {
          tempData.push(element);
        }
      });
      context.commit("parentCertificates", tempData);
    },
    async GET_TEACHER_MODULES(context) {
      const results = await TeacherService.fetchTeacherModules({
        id: router.currentRoute.params.id,
      });

      const data = results.data.modules;
      context.commit("modules", data);
    },
    async SEARCH_TEACHERS_LIST(context) {
      const res = await SearchService.searchTeachers(
        context.rootState.searches.name
      );
      const data = await res.data.results;
      context.commit("teachers", data);
    },
    async RESET_TEACHERS_STATE(context) {
      await context.commit("resetTeachers");
    },
  },
  getters: {
    salutation: (state) => {
      if (state.teacher.sex.toUpperCase() === "MALE") {
        return "Mr.";
      }
      if (state.teacher.sex.toUpperCase() === "FEMALE") {
        return "Ms.";
      }
      return "";
    },
  },
};

export default teachers;
